// Endpoints do painel Arquivos (cópia do subconjunto FILES_* do lib/api do
// crm-twms — o ArquivosLab.tsx é cópia verbatim de lá e importa daqui).
// No fin, /api/files/* é proxy fino streaming pro crm-twms-backend
// (routes/crm-inbox.cjs, filesProxy) — a lógica/SMB gateway vive no crm.
export const API_ENDPOINTS = {
  FILES_LIST: '/api/files/list',
  FILES_SEARCH: '/api/files/search',
  FILES_DOWNLOAD: '/api/files/download',
  FILES_UPLOAD: '/api/files/upload',
  FILES_EDIT_CONFIG: '/api/files/edit-config',
  FILES_VERSIONS: '/api/files/versions',
  FILES_VERSION_CONTENT: '/api/files/version-content',
  FILES_RESTORE: '/api/files/restore',

  // Painel Dados (Oracle AI) — mesmo desenho do FILES_*: o DadosPanel.tsx é
  // cópia do InfrastructureDBPanel.tsx do crm e /api/oracle/* é proxy streaming
  // pro crm-twms-backend (streamProxy). Oracle, vault e sidecar ficam lá.
  ORACLE_TEST_CONNECTION: '/api/oracle/test-connection',
  ORACLE_QUERY: '/api/oracle/query',
  ORACLE_QUERY_HISTORY: '/api/oracle/query-history',
  ORACLE_AI_GENERATE: '/api/oracle/ai-generate',
  ORACLE_AI_REPORT: '/api/oracle/ai-report',
  ORACLE_REPORT_PDF: '/api/oracle/report-pdf',
  ORACLE_REPORT_JOBS: '/api/oracle/report-jobs',
  ORACLE_QUICK_COMMANDS: '/api/oracle/quick-commands',
  ORACLE_QUICK_COMMANDS_DETECT: '/api/oracle/quick-commands/detect-variables',
  ORACLE_DEEP_LEARN: '/api/oracle/deep-learn',
  ORACLE_LEARN_STATUS: '/api/oracle/learn-status',
  WHISPER_TRANSCRIBE: '/api/whisper/transcribe', // ditado por voz da pergunta
}
